import { CUSTOMERS_PATH } from 'installations/navigation';

const indexComponent = require('./routes/index/components/InstallationCustomersList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: CUSTOMERS_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/add'),
        require('./routes/show'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/InstallationCustomers'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/routes/show/routes/customers/index.js